module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_folder_remoteEntry_mjs_7c601edf__;